import { ApolloClient, InMemoryCache } from '@apollo/client';
import { GraphQLAuthHeader } from '../../constants/constant';
import ApiEndpoints from '../../constants/apiconstants';
import { getCurrentEnv } from '../../helper/helper';

let headers = {};

if (getCurrentEnv() === 'local') {
	headers.Authorization = GraphQLAuthHeader;
	headers['Company-Id'] = '0014M00002E7OiRQAV';
	headers['Company-Name'] = 'THE PROCTER & GAMBLE COMPANY';
}

const client = new ApolloClient({
	uri: ApiEndpoints.GRAPHQL,
	cache: new InMemoryCache({
		addTypename: false,
	}),
	headers,
});

export const apolloHeaders = (operationName) => {
	if (!operationName) {
		throw new Error('Operation name is required');
	}

	return {
		'X-Apollo-Operation-name': operationName,
		'x-app-id': 'CHANNELPERFORMANCE_INSIGHTS',
	};
};

export default client;
